/**
 * Sort helpers — keep newest entries on top of every list.
 */

/**
 * Comparator for "newest first" sorting.
 * Uses `created_at` (ISO string or Date) with fallbacks to `createdAt`, `date`, then id.
 * Items without any timestamp fall to the bottom.
 */
export const byNewestFirst = (a, b) => {
  const ta = new Date(a?.created_at || a?.createdAt || a?.date || 0).getTime() || 0;
  const tb = new Date(b?.created_at || b?.createdAt || b?.date || 0).getTime() || 0;
  if (tb !== ta) return tb - ta;
  // Tie-breaker: id desc (later ids generally mean later rows)
  return String(b?.id || '').localeCompare(String(a?.id || ''));
};

/** Returns a new array sorted by `byNewestFirst`. Safe against non-array inputs. */
export const sortNewestFirst = (arr) => (Array.isArray(arr) ? [...arr].sort(byNewestFirst) : []);
